export const Distance = {
  KM: 'km',
  MI: 'mi',
};

export const MILES_TO_METERS = 1609.34;

// Offset for rounding distances up to the nearest bigger value
export const DISTANCE_ROUNDING_OFFSET = 0.499;
